var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "problem-list mr-3 mr-lg-0" },
    [
      _vm.inAssignment
        ? _c(
            "div",
            { staticClass: "active", attrs: { "data-breadcrumbs": "" } },
            [
              _c(
                "span",
                [
                  _c(
                    "a",
                    {
                      staticClass: "breadcrumbs-link",
                      attrs: { href: "/course/" }
                    },
                    [_vm._v(_vm._s(_vm.T.navCourses))]
                  ),
                  _vm._v(" > "),
                  _c(
                    "a",
                    {
                      staticClass: "breadcrumbs-link",
                      attrs: { href: _vm.urlAssignment }
                    },
                    [_vm._v(_vm._s(_vm.courseName))]
                  ),
                  _vm.currentAssignment
                    ? [
                        _vm._v(" > "),
                        _c("span", { staticClass: "breadcrumbs-link" }, [
                          _vm._v(_vm._s(_vm.currentAssignment.name))
                        ])
                      ]
                    : _vm._e()
                ],
                2
              )
            ]
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "summary", class: { active: !_vm.activeProblem } },
        [
          _c(
            "a",
            {
              staticClass: "name",
              attrs: { href: "#problems" },
              on: {
                click: function($event) {
                  return _vm.$emit("disable-active-problem")
                }
              }
            },
            [_vm._v(_vm._s(_vm.T.wordsSummary))]
          )
        ]
      ),
      _vm._l(_vm.problems, function(problem) {
        return _c(
          "div",
          {
            key: problem.alias,
            class: { active: problem.alias === _vm.activeProblem },
            attrs: { "data-navbar-problem": "" }
          },
          [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-5 problem-type w-50 pl-4" }, [
                _vm.inAssignment
                  ? _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.getProblemTypeTitle(problem.acceptsSubmissions)
                        )
                      )
                    ])
                  : _vm._e()
              ]),
              problem.acceptsSubmissions
                ? _c(
                    "div",
                    { staticClass: "col-xs-7 solved text-right w-50 pr-3" },
                    [
                      _c("span", { staticClass: "mr-1" }, [
                        _vm._v(_vm._s(_vm.getMaxScoreForProblem(problem)))
                      ]),
                      problem.myBestScore == problem.maxScore ||
                      problem.bestScore == problem.maxScore
                        ? _c("font-awesome-icon", {
                            style: { color: "green" },
                            attrs: { icon: "check" }
                          })
                        : problem.hasMyRuns ||
                          (problem.hasRuns && problem.hasMyRuns === null)
                        ? _c("font-awesome-icon", {
                            style: { color: "red" },
                            attrs: { icon: "times" }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-12 pl-4" }, [
                _c(
                  "a",
                  {
                    staticClass: "name",
                    attrs: { "data-problem": problem.alias },
                    on: {
                      click: function($event) {
                        return _vm.onNavigateToProblem(problem)
                      }
                    }
                  },
                  [_vm._v(_vm._s(problem.text))]
                )
              ])
            ])
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }